<template>
  <router-view />
</template>

<script>
  export default {
    name: 'AquaGISApp',
  }
</script>
